import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tool-arrow-up",
  "use": "tool-arrow-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 16 16\" id=\"tool-arrow-up\">\r\n<path d=\"M4.867 10.052c-0.309 0.301-0.81 0.301-1.13 0.010-0.301-0.283-0.317-0.785 0-1.063l3.698-3.5c0.31-0.291 0.82-0.291 1.13 0l3.698 3.5c0.32 0.291 0.32 0.762 0 1.063-0.309 0.291-0.821 0.291-1.13-0.010l-3.133-2.958-3.133 2.958z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol